import React, { RefObject }  from "react";
import { PreviewMeasurement } from "../Models/PreviewMeasurement";
import { StudyModel } from "../Models/StudyModel";
import { DataHelper } from "../Helpers/DataHelper";
import DoubleDragBar from "./DoubleDragBar";
import { ErrorWindow } from "../Components/ErrorWindow";

export class LargeImagingPlayer extends React.Component<
    {
        rowData: PreviewMeasurement,
        studySelected: StudyModel,
        dataHelper: DataHelper,
        previewAvailable: boolean,
        context: string, 
        procedureId: string,
        closeClicked: ()=>void,
        width: number,
        orientationChanged?: (value :string) => void

    },
    {
        startTime: number,
        endTime: number,
        fullTime: number
    }
> {
   errorWindow:  RefObject<ErrorWindow>;
    constructor(props: any) {
        super(props);
        this.errorWindow = React.createRef();
        this.state = {
            startTime: 0,
            endTime: 0,
            fullTime: 5
        }
    }

    static defaultProps = {
        //Set any properties that are optional when creating the component.
        context: "",
        previewAvailable: true,
        width: 960
      }

    

      componentDidMount(): void {
        const videoElement = document.getElementById("my-video") as HTMLVideoElement;
    
        if (videoElement) {
          videoElement.onloadedmetadata = () => {
            this.setState({ endTime: videoElement.duration, fullTime:  videoElement.duration});
          };
        }
      }
    setTimes = () => {
        const { startTime, endTime } = this.state;
        const videoElement = document.getElementById("my-video") as HTMLVideoElement;
    
        if (videoElement) {
          videoElement.currentTime = startTime;
    
          videoElement.ontimeupdate = () => {
            if (videoElement.currentTime >= endTime -0.001) {
                videoElement.currentTime = startTime;
            //   videoElement.pause();
            }
          };
          videoElement.onended  = () => {
                videoElement.currentTime = startTime;
                videoElement.play();
          };
        }
      };


      downloadVideo = () => {

        this.props.dataHelper.CallMetadataService("TrimVideoFile", {
            measurementId: this.props.rowData.id,
            procedureId: this.props.procedureId,
            studyId: this.props.studySelected.id, 
            startTime: this.state.startTime,
            endTime: this.state.endTime
        },{}, (resultOut: string) => {
          let filename = JSON.parse(resultOut);
          if (filename !== "ERROR")
          {
            this.props.dataHelper.downloadFile("StudyMetadata", "GetFile", {fileid: filename});
          }else
          {
            (this.errorWindow.current as ErrorWindow).show(500, "Trimming the video file failed.");
          }
        },(status:number, errorMessage:string)=>
            { 
                   (this.errorWindow.current as ErrorWindow).show(status, errorMessage);


        },"POST");
      }

     getCurrentFrame = () => {
    const video = document.getElementById("my-video") as HTMLVideoElement;
    const canvas = document.createElement("canvas") as HTMLCanvasElement;

    // Check if video is loaded and has dimensions
    if (video && video.videoWidth > 0 && video.videoHeight > 0) {
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        const context = canvas.getContext('2d');
        if (context) {
            context.drawImage(video, 0, 0, canvas.width, canvas.height);
            const dataURL = canvas.toDataURL('image/png');
            const link = document.createElement('a');
            link.href = dataURL;
            link.download = 'screenshot.png';
            link.click();
        }
    } else if (video && video.poster) {
        // If video is not loaded, use the poster image
        const img = new window.Image();
        img.crossOrigin = "anonymous";
        img.onload = function () {
            canvas.width = img.width;
            canvas.height = img.height;
            const context = canvas.getContext('2d');
            if (context) {
                context.drawImage(img, 0, 0, canvas.width, canvas.height);
                const dataURL = canvas.toDataURL('image/png');
                const link = document.createElement('a');
                link.href = dataURL;
                link.download = 'screenshot.png';
                link.click();
            }
        };
        img.src = video.poster;
    }
}

    render() {
     let dateParsed = new Date( this.props.rowData.recordDate as any) as Date;
        return (
            
            
            <>
            <ErrorWindow ref={this.errorWindow}/>
               <div className="imagingContainer">
            <div className="imagingFullPreview">
                <video
                id="my-video"
                className="video-player full-imaging"
                controls
                preload="auto"
                width={this.props.width} crossOrigin="anonymous" 
                loop={false}
                poster={this.props.dataHelper.hostAddress + "MiscData/GetImagingPreview?studyId=" + this.props.studySelected.id + "&measurementId=" +  this.props.rowData.id+ "&procedureId=" +  this.props.procedureId+ "&tokenId=" +  this.props.dataHelper.miscToken}
                data-setup="{}"
                onLoad={()=>
                {
                    
                }
                }
            >
                <source src={this.props.dataHelper.hostAddress + "stream?procedureId=" + this.props.procedureId+"&studyId=" +  this.props.studySelected.id +"&measurementId=" +  this.props.rowData.id + "&tokenId=" +  this.props.dataHelper.miscToken} type="video/mp4" />
                <p className="vjs-no-js">
                To view this video please enable JavaScript, and consider upgrading to a
                web browser that
                <a href="https://videojs.com/html5-video-support/" >supports HTML5 video</a>
                </p>
            </video>
            {this.props.orientationChanged ?
                    <div className="thumbDataItem imagingOrientationSwitch toggleButtonsWraper">
                      <button className={"imagingOrientationButton primaryButton " + (this.props.rowData.orientation === "Transverse" ? "Pressed" : "")} onClick={(e)=>
                        {if (this.props.orientationChanged) this.props.orientationChanged("Transverse");  e.preventDefault();

                        }}>Transverse</button>
                        <button className={"imagingOrientationButton primaryButton " +  (this.props.rowData.orientation === "Longitudinal" ? "Pressed" : "")} onClick={(e)=>
                            {
                                if (this.props.orientationChanged) 
                                    this.props.orientationChanged("Longitudinal"); 
                                e.preventDefault();
                            }}>Longitudinal</button>
                      </div>
                    : <></>}
            <div className="probeChannelWrap">
                        <button className="probeChannelButton intui-button">
                            <div className="channelButtonLabel">{this.props.rowData.operatingMode ?  this.props.rowData.operatingMode.replace("OperatingMode", "") : ""}</div>
                        </button>
                        {this.props.studySelected.exportEnabled&&
                        <>
                        <button className="saveVideoButton intui-button save-image" onClick={this.downloadVideo}>
                            <span><img alt="Download video interval" src="/videoCapture.svg" title="Download video"/></span>
                        </button>
                        <button className="intui-button save-image" onClick={this.getCurrentFrame}>
                        <span><img alt="Screen Capture" src="/screenCapture.svg" title="Screenshoot capture"/></span>
                        </button>
                        </>
                        }
                        <div className="anatomicalLabel">
                          <div>{(this.props.rowData.anatomicalLocations != null && this.props.rowData.anatomicalLocations.length > 0) ? this.props.rowData.anatomicalLocations?.join('-') : "Location Undefined"}</div>
                        </div>
                        <div className="measurementdatetime">
                        {dateParsed.toLocaleString()}
                    </div>
                    </div>
                    
                    </div>
            <div className="sliderWrapper videoSlider">
              
              <DoubleDragBar name={"compareVideoSlider"} value1={this.state.startTime} value2={this.state.endTime} max={this.state.fullTime} min={0} onChange={(value1: number, value2: number)=>{
                    this.setState({ 
                        startTime: value1,
                        endTime: value2
                    }, ()=>{
                        this.setTimes();
                    });
                    
              }}  height={80} width={this.props.width + 100}></DoubleDragBar> 
              <label>Drag slider to choose video interval</label>
           </div>
           
           </div>
            </>
        );
    }
}


